module.exports = __webpack_public_path__ + "static/day11-b26c57a1bd1a4ca26180779bd2d6449b.png";